import { Component } from '@angular/core';

/** /intro es el intro clásico. La suite no tiene esta pantalla. */
@Component({
  selector: 'app-intro-gate',
  standalone: false,
  template: `<app-intro></app-intro>`,
})
export class IntroGateComponent {}
